import { AuthLayout } from '@/design-system/layouts'
import { ChangePassword } from '../components'

export function ChangePasswordPage() {
  return (
    <AuthLayout>
      <ChangePassword />
    </AuthLayout>
  )
}
